import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MenuRoutingModule } from './menu-routing.module';
import { AppTransModule } from '../app-trans/app-trans.module';




@NgModule({
  declarations: [ ],
  imports: [
    CommonModule,
    MenuRoutingModule
  ],
  entryComponents: [],
  providers:[]
})
export class MenuModule { }
